// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {hasPermission} from '../../services/privacy';

export const privatize = rule =>
    WrappedComponent => {

        const PrivacyWrappedComponent = (props, context) =>
            hasPermission(context.user.privacy, rule) ?
                <WrappedComponent{...props}/> : null;

        PrivacyWrappedComponent.WrappedComponent = WrappedComponent;
        PrivacyWrappedComponent.contextTypes = {
            user: PropTypes.instanceOf(User).isRequired
        };

        return PrivacyWrappedComponent;

    };



// WEBPACK FOOTER //
// ./src/shared/components/privacy-wrapper/index.js